import Swiper, {Navigation, Pagination, EffectFade, Autoplay, Scrollbar} from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Scrollbar]);

class Carousel {
  public selector: any;
  public element: any;
  public carousel: Swiper;
  private settings: any = {};
  private defaultSettings: object = {
    direction: 'horizontal',
    loop: true,
  };

  constructor(selector: any, settings: any = {}) {
    this.selector = selector;
    this.settings = {
      ...this.defaultSettings,
      ...settings,
    };
  }

  cache() {
    const {selector} = this;
    this.element =
      selector instanceof HTMLElement
        ? selector
        : document.querySelector(selector);
  }

  initCarousel() {
    const {element} = this;
    if (!element) {
      return;
    }
    const {settings} = this;
    this.carousel = new Swiper(element, settings);
  }

  init() {
    const {selector} = this;
    if (selector) {
      this.cache();
      this.initCarousel();

      setTimeout(() => {
        this.carousel.update();
      }, 2000);
    }
  }
}

export default Carousel;
